export default {
  interviewMethod: '面试方式：',
  duration: '所需时间：',
  interviewTime: '面试时间：',
  meetingLink: '面试链接：',
  note: '备注：',
  availableTimeSlots: '可选面试时段：',
  mins: '分钟',
  rejectButton: '拒绝面试邀请',
  acceptButton: '接受面试邀请',
  rejectMessage: '拒绝面试邀请',
  selectTimeWarning: '请先选择一个时间段',
  acceptMessage: '接受面试邀请，选择的时间：{time}',
  fetchError: '获取面试信息失败，请稍后重试',
  candidate: '候选人：',
  to: '至',
  accepted: '已接受面试邀请',
  rejected: '已拒绝面试邀请',
  expired: '面试邀请已过期',
  rejectionReason: '拒绝原因：',
  online: '线上',
  offline: '线下',
  interviewInvitation: '面试邀请',
  rejectSuccess: '已成功拒绝面试邀请',
  rejectError: '拒绝面试失败，请稍后重试',
  acceptSuccess: '已成功接受面试邀请',
  acceptError: '接受面试失败，请稍后重试',
  invalidTimeSlot: '无效的时间段',
  rejectDialogTitle: '拒绝面试邀请',
  rejectReasonPlaceholder: '拒绝原因',
  cancelButton: '取消',
  acceptDialogTitle: '接受面试邀请',
  defaultNote: '如不能按时参加，请提前告知'
};
